import i18n from 'i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './en';

i18n
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'htmlTag', 'navigator'],
    },
    resources: { en },
    ns: ['common'],
    defaultNS: 'common',
    fallbackNS: ['common'],
    debug: false,
    nsSeparator: ':',
  });

i18n.changeLanguage('en');

export default i18n;
